import React, { useState, useEffect } from 'react';
import Footer from '../../../compontents/footer';
import { cloneDeep } from 'lodash';
import { Pagination, ConfigProvider, Popover } from 'antd'
import { DownOutlined } from '@ant-design/icons';
import zhCN from 'antd/lib/locale/zh_CN'
import axios from 'axios';
import QrcodeModal from '../../../compontents/QrcodeModal';
import './index.less';

const ProductListPage = (props) => {

  const cateItem1 = [
    { title: '不限', id: '123' },
    { title: '7天无理由', id: 'isSevenDayReturn' },
    { title: '租满即送', id: 'minRentFull' },
    { title: '随租随还', id: 'isReturnAnyTime' },
    { title: '包邮', id: 'isPackageMail' },
    { title: '首月一元', id: 'firstRentOneCoupon' },
    { title: '首月五折', id: 'firstRentFiveCoupon' },
  ]

  const cateItem2 = [
    { title: '不限', id: '123' },
    { title: '全新', id: 1 },
    { title: '99新', id: 2 },
    { title: '95新', id: 3 },
    { title: '9成新', id: 4 },
    { title: '8成新', id: 5 },
    { title: '7成新', id: 6 },
  ]

  const cateParams = [
    // {
    //   title: '发货与服务',
    //   type: 1,
    //   data: [
    //     { title: '不限', id: '123' },
    //     { title: '7天无理由', id: 'isSevenDayReturn' },
    //     { title: '租满即送', id: 'minRentFull' },
    //     { title: '随租随还', id: 'isReturnAnyTime' },
    //     { title: '包邮', id: 'isPackageMail' },
    //     { title: '首月一元', id: 'firstRentOneCoupon' },
    //     { title: '首月五折', id: 'firstRentFiveCoupon' },
    //   ]
    // },
    // {
    //   title: '新旧程度',
    //   type: 2,
    //   data: [
    //     { title: '不限', id: '123' },
    //     { title: '全新', id: 1 },
    //     { title: '99新', id: 2 },
    //     { title: '95新', id: 3 },
    //     { title: '9成新', id: 4 },
    //     { title: '8成新', id: 5 },
    //     { title: '7成新', id: 6 },
    //   ]
    // },
    {
      title: '起租日',
      type: 3,
      data: [
        { title: '不限', id: '123' },
        { title: '1天起租', id: 1 },
        { title: '3天起租', id: 3 },
        { title: '7天起租', id: 7 },
        { title: '30天起租', id: 30 },
        { title: '90天起租', id: 90 },
        { title: '180天起租', id: 180 },
        { title: '365天起租', id: 365 },
      ]
    },
    {
      title: '支持自提',
      type: 4,
      data: [
        { title: '不限', id: '123' },
        { title: '支持', id: 1 },
        { title: '不支持', id: 0 },
      ]
    },
  ]
  const urlParams = new URLSearchParams(window.location.search);
  const [cateItem1Click, setCateItem1Click] = useState(['123'])
  const [cateItem2Click, setCateItem2Click] = useState(['123'])
  const [checkId, setCheckId] = useState(['123', '123', '123', '123']);
  const [productList, setProductList] = useState([])
  const [searchCondition, setSearchCondition] = useState({
    pageSize: 20,
    pageNumber: 1,
    // oldNewDegreeStatus:1,
    // searchType:1
  })
  const [showTable, setShowTable] = useState({
    total: 0,
    pages: 0,
    current: 0
  })
  const [addressList, setAddressList] = useState([])
  const [addressName, setAddressName] = useState(undefined)
  const [clickPar, setClickPar] = useState(undefined);
  const [priceName, setPriceName] = useState(undefined)
  const [addressIds, setAddressIds] = useState([])
  const [isShowQrcode, setIsShowQrcode] = useState(false);
  const [productCode, setProductCode] = useState(null)

  const getOld = new Map([
    [1, '全新'],
    [2, '99新'],
    [3, '95新'],
    [4, '9成新'],
    [5, '8成新'],
    [6, '7成新'],
  ]);

  const productData = [
    {}, {}, {}, {}, {}, {}, {}, {}, {}, {}, {}, {}, {}, {}, {}, {}, {}, {}, {}, {},
  ]

  useEffect(() => {


    // const flag = urlParams.get('flag'); 
    const categoryId = urlParams.get('categoryId'); // "11752"
    if (categoryId) {
      getData(1)
    } else {
      getData(2)
    }

    // console.log(flag, categoryId); // 输出: "8" "11752"

    // console.log(window.location.search, 'windouw')
    return

  }, [searchCondition])

  const submitForm = (data) => axios({
    headers: {
      'Content-Type': 'application/json'
    },
    method: 'post',
    url: '/consumer-zhifubao/aliPay/index/aositem',
    responseType: 'json',
    data
  })

  const submitForm1 = (data) => axios({
    headers: {
      'Content-Type': 'application/json'
    },
    method: 'post',
    url: '/consumer-zhifubao/aliPay/index/aositemCategoryProduct',
    responseType: 'json',
    data
  })

  const getData = (type) => {
    if (type == 1) {
      const categoryId = urlParams.get('categoryId');
      submitForm1({
        operateCategoryId: categoryId,
        ...searchCondition,
      }).then(res => {
        setProductList(res?.data?.data?.records)
        setShowTable({
          total: res?.data?.data?.total,
          pages: res?.data?.data?.pages,
          current: res?.data?.data?.current
        })
        setAddressList(res?.data?.data?.cityCodes)
      })
    } else {
      const param = urlParams.get('param');
      submitForm({
        ...searchCondition,
        content: param,
      }).then(res => {
        setProductList(res?.data?.data?.records)
        setShowTable({
          total: res?.data?.data?.total,
          pages: res?.data?.data?.pages,
          current: res?.data?.data?.current
        })
        setAddressList(res?.data?.data?.cityCodes)
      })
    }

  }

  const changeParams = (type, id) => {
    let ids = cloneDeep(checkId)
    if (ids[type - 1] === id) {
      ids[type - 1] = '123'
    } else {
      ids[type - 1] = id
    }
    setCheckId(ids)
    if (type === 1) {
      let params = {}
      if (id !== '123') {
        params[id] = 1
      }
      setSearchCondition((prevState) => ({
        ...prevState,
        pageNumber: 1,
        isSevenDayReturn: undefined,
        minRentFull: undefined,
        isReturnAnyTime: undefined,
        isPackageMail: undefined,
        firstRentOneCoupon: undefined,
        firstRentFiveCoupon: undefined,
        ...params
      }));
    } else if (type === 2) {
      setSearchCondition((prevState) => ({
        ...prevState,
        pageNumber: 1,
        oldNewDegreeStatusList: id == '123' ? undefined : [id]
      }));
    } else if (type === 3) {
      setSearchCondition((prevState) => ({
        ...prevState,
        pageNumber: 1,
        minRentCycleDays: (id == '123' || ids[type - 1] === '123') ? undefined : id
      }));
    } else if (type === 4) {
      setSearchCondition((prevState) => ({
        ...prevState,
        pageNumber: 1,
        isSiteSelf: (id == '123' || ids[type - 1] === '123') ? undefined : id
      }));
    }

  }

  const changeParamsNew = (type, id) => {
    if (type === 1) {
      let ids = cloneDeep(cateItem1Click)
      if (id == '123') {
        setCateItem1Click(['123'])
        setSearchCondition((prevState) => ({
          ...prevState,
          pageNumber: 1,
          isSevenDayReturn: undefined,
          minRentFull: undefined,
          isReturnAnyTime: undefined,
          isPackageMail: undefined,
          firstRentOneCoupon: undefined,
          firstRentFiveCoupon: undefined,
        }))
      } else {
        if (ids.includes(id)) {
          ids = ids.filter(item => item !== id)
        } else {
          ids.push(id)
        }
        let newIds = ids.filter(item => item !== '123')
        if (newIds.length == 0) {
          setCateItem1Click(['123'])
          setSearchCondition((prevState) => ({
            ...prevState,
            pageNumber: 1,
            isSevenDayReturn: undefined,
            minRentFull: undefined,
            isReturnAnyTime: undefined,
            isPackageMail: undefined,
            firstRentOneCoupon: undefined,
            firstRentFiveCoupon: undefined,
          }))
          return
        }
        setCateItem1Click(newIds)
        let allParams = {}
        newIds.map(item => (
          allParams[item] = 1
        ))
        // console.log(allParams, 'allParams')
        // return
        setSearchCondition((prevState) => ({
          ...prevState,
          isSevenDayReturn: undefined,
          minRentFull: undefined,
          isReturnAnyTime: undefined,
          isPackageMail: undefined,
          firstRentOneCoupon: undefined,
          firstRentFiveCoupon: undefined,
          pageNumber: 1,
          ...allParams
        }))
      }
    } else if (type === 2) {
      let ids = cloneDeep(cateItem2Click)
      if (id == '123') {
        setCateItem2Click(['123'])
        setSearchCondition((prevState) => ({
          ...prevState,
          pageNumber: 1,
          oldNewDegreeStatusList: undefined
        }))
      } else {
        if (ids.includes(id)) {
          ids = ids.filter(item => item !== id)
        } else {
          ids.push(id)
        }
        let newIds = ids.filter(item => item !== '123')
        if (newIds.length == 0) {
          setCateItem2Click(['123'])
          setSearchCondition((prevState) => ({
            ...prevState,
            pageNumber: 1,
            oldNewDegreeStatusList: undefined
          }))
          return
        }
        setCateItem2Click(newIds)
        // let allParams = {}
        // newIds.map(item => (
        //   allParams[item] = 1
        // ))
        // console.log(newIds, 'allParams')
        // return
        setSearchCondition((prevState) => ({
          ...prevState,
          pageNumber: 1,
          oldNewDegreeStatusList: newIds
        }))
      }
    }
  }



  //下一页
  function onChange(pageNumber) {
    setSearchCondition((prevState) => ({
      ...prevState,
      pageNumber
    }));
  }

  const resetAll = () => {
    const categoryId = urlParams.get('categoryId');
    const param = urlParams.get('param');
    if (categoryId) {
      setSearchCondition((prevState) => ({
        pageNumber: 1,
        pageSize: 20,
        operateCategoryId: categoryId || undefined,
        // content: param || '笔记本'

      }));
    } else {
      window.location.href = `${window.location.origin}${window.location.pathname}?flag=${8}&param=${'笔记本'}`
    }

    setClickPar(undefined)
    setPriceName(undefined)
    setAddressName(undefined)
    setCheckId(['123', '123', '123', '123'])
    setCateItem1Click(['123'])
    setCateItem2Click(['123'])
    setAddressIds([])
  }



  const selectAddress = (code) => {
    let addArr = cloneDeep(addressIds)
    if (addArr.includes(code)) {
      addArr = addArr.filter(item => item !== code)
    } else {
      addArr.push(code)
    }
    console.log(addArr, 'addArr')
    setAddressIds(addArr)

    setSearchCondition((prevState) => ({
      ...prevState,
      pageNumber: 1,
      searCityCodeList: addArr ? addArr : undefined
    }));
  }

  const selectScal = (item) => {
    setClickPar(item)
    setSearchCondition((prevState) => ({
      ...prevState,
      pageNumber: 1,
      saleSort: item === '由低到高' ? 1 : null
    }));
  }

  const selectPrice = (item) => {
    setPriceName(item)
    setSearchCondition((prevState) => ({
      ...prevState,
      pageNumber: 1,
      orderBy: item === '由低到高' ? 'asc' : 'desc'
    }));
  }

  const autoPop = (str, n = 10) => {
    let name = str.slice(0, n) + '...'
    let r = str
    if (str.length > n) {
      r = (
        <Popover
          // overlayClassName={'Popover'}
          style={{ wordBreak: 'break-all' }}
          placement="top"
          title={false}
          content={str}
          trigger="hover"
        >
          {name}
        </Popover>
      )
    }
    return r
  }


  return (
    <div className='ProductListPage'  >
      <div className='ProductListPageBox' >
        <div className='ProductListPageBox_search' >
          <div className='ProductListPageBox_search_top' >
            <div className='ProductListPageBox_search_top_title' >全部分类</div>
            <div></div>
            <div className='ProductListPageBox_search_top_resetBtn' onClick={() => resetAll()} >
              重置筛选
            </div>

          </div>
          <div className='ProductListPageBox_search_line' >

          </div>

          <div className='ProductListPageBox_search_item' >
            <div className='ProductListPageBox_search_item_title' >
              发货与服务
            </div>
            <div className='ProductListPageBox_search_item_tagBox' >
              {cateItem1.map(_item => (
                <div
                  onClick={() => changeParamsNew(1, _item.id)}
                  className={cateItem1Click.includes(_item.id) ? 'ProductListPageBox_search_item_tagBox_tagClick' : 'ProductListPageBox_search_item_tagBox_tag'}
                >
                  {_item.title}
                </div>
              ))}
            </div>
          </div>
          <div className='ProductListPageBox_search_item' >
            <div className='ProductListPageBox_search_item_title' >
              新旧程度
            </div>
            <div className='ProductListPageBox_search_item_tagBox' >
              {cateItem2.map(_item => (
                <div
                  onClick={() => changeParamsNew(2, _item.id)}
                  className={cateItem2Click.includes(_item.id) ? 'ProductListPageBox_search_item_tagBox_tagClick' : 'ProductListPageBox_search_item_tagBox_tag'}
                >
                  {_item.title}
                </div>
              ))}
            </div>
          </div>
          {cateParams.map(item => (
            <div className='ProductListPageBox_search_item' >
              <div className='ProductListPageBox_search_item_title' >
                {item.title}
              </div>
              <div className='ProductListPageBox_search_item_tagBox' >
                {item.data.map((_item, index) => (
                  <div
                    onClick={() => changeParams(item.type, _item.id)}
                    className={checkId[item.type - 1] === _item.id ? 'ProductListPageBox_search_item_tagBox_tagClick' : 'ProductListPageBox_search_item_tagBox_tag'}
                  >
                    {_item.title}
                  </div>
                ))}
              </div>
            </div>
          ))}
          <div className='ProductListPageBox_search_line' >

          </div>
          <div style={{ display: 'flex' }} >
            <div className='ProductListPageBox_search_hoverBox' >
              {addressList && addressList.length > 0 && (
                <div className='ProductListPageBox_search_hoverBox_address' >
                  {addressList.map(item => (
                    <div className={addressIds.includes(item.cityCode) ? 'ProductListPageBox_search_hoverBox_address_itemClick' : 'ProductListPageBox_search_hoverBox_address_item'} onClick={() => { selectAddress(item.cityCode); }} >
                      {item.cityName}
                    </div>
                  ))}
                </div>
              )}

              <div className={addressName ? 'ProductListPageBox_search_hoverBox_itemClick' : 'ProductListPageBox_search_hoverBox_item'} >
                <div >
                  {addressName ? addressName : '发货地'}
                </div>
                <DownOutlined className='ProductListPageBox_search_hoverBox_item_icon' />
              </div>

            </div>
            <div className='ProductListPageBox_search_hoverBox1' >
              <div className={clickPar ? 'ProductListPageBox_search_hoverBox1_itemClick' : 'ProductListPageBox_search_hoverBox1_item'}  >
                <div>
                  {clickPar ? clickPar : '销量'}
                </div>
                <DownOutlined className='ProductListPageBox_search_hoverBox_item_icon' />
              </div>
              <div className='ProductListPageBox_search_hoverBox1_hoverBox' >
                <div className='ProductListPageBox_search_hoverBox1_hoverBox_item' onClick={() => selectScal('由低到高')} >由低到高</div>
                <div className='ProductListPageBox_search_hoverBox1_hoverBox_item' onClick={() => selectScal('由高到低')} >由高到低</div>
              </div>
            </div>
            <div className='ProductListPageBox_search_hoverBox2' >
              <div className={priceName ? 'ProductListPageBox_search_hoverBox2_itemClick' : 'ProductListPageBox_search_hoverBox2_item'} >
                <div>
                  {priceName ? priceName : '价格'}
                </div>
                <DownOutlined className='ProductListPageBox_search_hoverBox_item_icon' />
              </div>

              <div className='ProductListPageBox_search_hoverBox2_hoverBox' >
                <div className='ProductListPageBox_search_hoverBox2_hoverBox_item' onClick={() => selectPrice('由低到高')} >由低到高</div>
                <div className='ProductListPageBox_search_hoverBox2_hoverBox_item' onClick={() => selectPrice('由高到低')} >由高到低</div>
              </div>
            </div>
            {/* <div className='ProductListPageBox_search_hoverBox3' >
              <div className='ProductListPageBox_search_hoverBox_item' >包邮</div>
            </div> */}
          </div>

        </div>
        <div className='ProductListPageBox_product' >
          {(productList && productList.length > 0) ? productList.map((item, index) => (
            <div className='ProductListPageBox_product_item' style={(index + 1) % 5 === 0 ? { marginRight: 0 } : {}} onClick={()=>{setProductCode(item?.itemId); setIsShowQrcode(true)} } >
              <div className='ProductListPageBox_product_item_pic' style={{ backgroundImage: `url(${item?.image})` }} >
                {item.unionProductStatus && (
                  <div className='ProductListPageBox_product_item_pic_fixIcon' >

                  </div>
                )}
              </div>
              <div className='ProductListPageBox_product_item_titleBox' >
                <div className='ProductListPageBox_product_item_titleBox_left' >
                  {getOld.get(Number(item?.oldNewDegree))}
                </div>
                <div className='ProductListPageBox_product_item_titleBox_right' >
                  {item?.name ? autoPop(item?.name,20) : '-'}
                </div>
              </div>
              <div className='ProductListPageBox_product_item_tagBox' >
                {item?.productServiceLabels && item?.productServiceLabels.length > 0 && (
                  item?.productServiceLabels.map(_item => (
                    <div className='ProductListPageBox_product_item_tagBox_tag' >
                      {_item?.serviceLabName}
                    </div>
                  ))
                )}
              </div>
              <div className='ProductListPageBox_product_item_bottom' >
                <div className='ProductListPageBox_product_item_bottom_left' >
                  <span>¥</span>
                  <span className='ProductListPageBox_product_item_bottom_left_big' >{item?.price || item?.minDailyRent}</span>
                  <span>/天</span>
                </div>
                <div className='ProductListPageBox_product_item_bottom_right' >
                  {item.deliveryLicenseProvince || '-'} {item.deliveryLicenseCity || '-'}
                </div>
              </div>
            </div>
          )) : (
            <div className='ProductListPageBox_product_empty' >
              <div className='ProductListPageBox_product_empty_pic' >

              </div>
              <div className='ProductListPageBox_product_empty_title' >
                暂无相关商品
              </div>
            </div>
          )}
        </div>
        {productList && productList.length > 0 && (
          <div className='ProductListPageBox_product_pagination' >
            共 {showTable.total} 条记录 第 {showTable.current}/{showTable.pages} 页
            <ConfigProvider locale={zhCN} theme={{ token: { colorPrimary: '#F52C1D' } }} >
              <Pagination
                className='ProductListPageBox_product_pagination_pagi'
                showQuickJumper
                defaultCurrent={1}
                total={showTable.total}
                onChange={onChange}
                showSizeChanger={false}
                pageSize={20}
              />
            </ConfigProvider>
          </div>
        )}
      </div>
      <Footer />
      {isShowQrcode && (
        <QrcodeModal
          visible={isShowQrcode}
          handleCancel={() => setIsShowQrcode(false)}
          productId={productCode}
        />
      )}
    </div>
  )
}

export default ProductListPage;